import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, Copy, Home, Sparkles } from 'lucide-react';
import '../styles/SuccessScreen.css';

function SuccessScreen({ vpnKey, setVpnKey, selectedVPN }) {
  const navigate = useNavigate();
  const [telegramId, setTelegramId] = useState(null);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    if (window.Telegram && window.Telegram.WebApp) {
      window.Telegram.WebApp.ready();
      window.Telegram.WebApp.expand();
      setIsIOS(window.Telegram.WebApp.platform === 'ios');
      const user = window.Telegram.WebApp.initDataUnsafe?.user;
      if (user?.id) setTelegramId(user.id);
    }

    if (process.env.NODE_ENV === 'development') {
      const params = new URLSearchParams(window.location.search);
      const tgIdFromUrl = params.get('tg_id');
      setTelegramId(tgIdFromUrl || 2075921486);
    }
  }, []);

  useEffect(() => {
    // Заглушка: генерация ключа
    setVpnKey('nebula-vpn-key-8f4k2p9x7q');
  }, [setVpnKey]);

  const handleCopy = () => {
    navigator.clipboard.writeText(vpnKey);
    // Можно заменить на более красивый toast, но пока alert
    alert('Ключ скопирован в буфер обмена!');
  };

  return (
    <div className="success-wrapper">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
        className="success-content"
      >
        {/* Большая иконка успеха */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2, type: 'spring', stiffness: 200 }}
          className="success-icon"
        >
          <CheckCircle size={120} strokeWidth={2} />
          <Sparkles className="sparkle-left" size={32} />
          <Sparkles className="sparkle-right" size={32} />
        </motion.div>

        {/* Заголовок */}
        <motion.h1
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="success-title"
        >
          Оплата успешна!
        </motion.h1>

        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="success-subtitle"
        >
          Ваш {selectedVPN.name} активирован. Добро пожаловать в свободный интернет!
        </motion.p>

        {/* Ключ */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="key-card"
        >
          <p className="key-label">Ваш ключ подключения</p>
          <p className="key-value">{vpnKey}</p>
          <motion.button
            whileTap={{ scale: 0.95 }}
            className="copy-button"
            onClick={handleCopy}
          >
            <Copy size={20} />
            Скопировать ключ
          </motion.button>
        </motion.div>

        {/* Инструкция */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.7 }}
          className="instructions"
        >
          <h3>Как подключиться:</h3>
          <ol>
            <li>Скачайте приложение <strong>{selectedVPN.name}</strong></li>
            <li>Откройте настройки → Импорт конфигурации</li>
            <li>Вставьте скопированный ключ</li>
            <li>Нажмите «Подключиться» и наслаждайтесь!</li>
          </ol>
        </motion.div>

        {/* Кнопка на главную */}
        <motion.button
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.9 }}
          whileTap={{ scale: 0.95 }}
          className="home-button"
          onClick={() => navigate('/')}
        >
          <Home size={20} />
          Вернуться на главную
        </motion.button>
      </motion.div>
    </div>
  );
}

export default SuccessScreen;